import axios from 'axios'
import { ElLoading, ElMessageBox } from 'element-plus'
import router from '../router'

let baseURL
if (process.env.NODE_ENV === 'production') {
  baseURL = '/api'// 正式
} else {
  // baseURL = 'http://127.0.0.1:8681/test/api'// 测试
  // baseURL = 'http://127.0.0.1:8681/api'// 测试
  baseURL = '/api'
}
// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // 测试
  timeout: 0
})
let loading

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = token
    }

    // 请求开始时显示加载状态
    if (!config.closeLoading) {
      loading = ElLoading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 将加载实例保存到请求配置中
      config.loading = loading
    }

    return config
  },
  (error) => {
    // 请求错误处理
    loading.close()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 请求成功处理
    loading.close()
    return response.data
  },
  (error) => {
    // 请求失败处理
    console.log(error, 'error>>>>>')

    if (error.response) {
      if (error.response.data.showAlert && error.response.data.showAlert === 1) {
        console.log('showAlert>>>>>>>>>')
        loading.close()
        return Promise.reject(error)
      } else {
        if (error.response.data.code) {
          if (error.response.data.code === -4 || error.response.data.code === -5) {
            sessionStorage.removeItem('token')
            ElMessageBox.alert(`${error.response.data.code_prompt}登录过期，请重新登录`, '温馨提示', {
              confirmButtonText: 'OK',
              callback: () => {
                router.push('/')
              }
            })
          } else {
            let mess = ''
            if (error.response.data.data) {
              mess = error.response.data.data.prompt
            } else {
              mess = error.response.data.error
            }
            ElMessageBox.alert(mess, '', {
              confirmButtonText: 'OK',
              callback: () => {
              }
            })
          }
        } else {
          if (error.response.data.message) {
            ElMessageBox.alert(error.response.data.message, '', {
              confirmButtonText: 'OK',
              callback: () => {
         
              }
            })
          } else {
            let val = ''
            if (error.response.data.error) {
              val = error.response.data.error
            } else {
              val = '服务器内部错误，请联系系统开发人员'
            }
            ElMessageBox.alert(val, '', {
              confirmButtonText: 'OK',
              callback: () => {
              }
            })
          }
        }
      }
    } else {
      ElMessageBox.alert('操作失败', '', {
        confirmButtonText: 'OK',
        callback: () => {
          // router.push('/')
        }
      })
    }
  
    loading.close()
    return Promise.reject(error)
  }
)

export default service
